var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 .5a.5.5 0 0 1 .5-.5H11a1 1 0 0 1 1 1v2.5a.5.5 0 0 1-1 0V1.707L5.854 6.854a.5.5 0 1 1-.708-.708L10.293 1H8.5A.5.5 0 0 1 8 .5M2.5 1A2.5 2.5 0 0 0 0 3.5v6A2.5 2.5 0 0 0 2.5 12h6A2.5 2.5 0 0 0 11 9.5v-3a.5.5 0 0 0-1 0v3A1.5 1.5 0 0 1 8.5 11h-6A1.5 1.5 0 0 1 1 9.5v-6A1.5 1.5 0 0 1 2.5 2h3a.5.5 0 0 0 0-1z",
    clipRule: "evenodd"
  })));
});
const SvgNewTabsmall = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNewTabsmall);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04IDAuNUM4IDAuMjIzODU4IDguMjIzODYgMCA4LjUgMEwxMSAwQzExLjU1MjMgMCAxMiAwLjQ0NzcxNSAxMiAxVjMuNUMxMiAzLjc3NjE0IDExLjc3NjEgNCAxMS41IDRDMTEuMjIzOSA0IDExIDMuNzc2MTQgMTEgMy41VjEuNzA3MTFMNS44NTM1NSA2Ljg1MzU1QzUuNjU4MjkgNy4wNDg4MiA1LjM0MTcxIDcuMDQ4ODIgNS4xNDY0NSA2Ljg1MzU1QzQuOTUxMTggNi42NTgyOSA0Ljk1MTE4IDYuMzQxNzEgNS4xNDY0NSA2LjE0NjQ1TDEwLjI5MjkgMUg4LjVDOC4yMjM4NiAxIDggMC43NzYxNDIgOCAwLjVaTTIuNSAxQzEuMTE5MjkgMSAwIDIuMTE5MjkgMCAzLjVMMCA5LjVDMCAxMC44ODA3IDEuMTE5MjkgMTIgMi41IDEySDguNUM5Ljg4MDcxIDEyIDExIDEwLjg4MDcgMTEgOS41VjYuNUMxMSA2LjIyMzg2IDEwLjc3NjEgNiAxMC41IDZDMTAuMjIzOSA2IDEwIDYuMjIzODYgMTAgNi41VjkuNUMxMCAxMC4zMjg0IDkuMzI4NDMgMTEgOC41IDExSDIuNUMxLjY3MTU3IDExIDEgMTAuMzI4NCAxIDkuNVYzLjVDMSAyLjY3MTU3IDEuNjcxNTcgMiAyLjUgMkg1LjVDNS43NzYxNCAyIDYgMS43NzYxNCA2IDEuNUM2IDEuMjIzODYgNS43NzYxNCAxIDUuNSAxSDIuNVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";